module.exports = __webpack_public_path__ + "img/127.0e76c648.png";